import { Container, Accordion } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
import "../style/FaqPreview.css";

const FAQS = [
  {
    q: "Do you add soda to your batter?",
    a: "No. Our batter is made using traditional methods, without any artificial additives or soda.",
  },
  {
    q: "Are there any preservatives?",
    a: "None. We believe in giving you a natural, healthy option for your meals — nothing added to extend shelf life.",
  },
  {
    q: "How fresh is the batter?",
    a: "We prepare it in small batches, so what you buy is close to what we just made — not stockpiled.",
  },
];

const FaqPreview = () => {
  return (
    <section className="section-pad faq-preview">
      <Container className="container-narrow container-narrow--tight">
        <SectionHeading eyebrow="Good to Know" title="Quick Answers" />
        <Reveal>
          <Accordion className="faq-preview__accordion">
            {FAQS.map(({ q, a }, i) => (
              <Accordion.Item eventKey={String(i)} key={q}>
                <Accordion.Header>{q}</Accordion.Header>
                <Accordion.Body>{a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Reveal>
        <div className="faq-preview__more">
          <a href="/faq">See all FAQs →</a>
        </div>
      </Container>
    </section>
  );
};

export default FaqPreview;
